import PenlyPlayDevelopmentGraph from './PenlyPlayDevelopmentGraph';

export default PenlyPlayDevelopmentGraph;
